
import React, { useEffect } from 'react';
import { useSessionStore } from '@/store/sessionStore';
import { Loader2 } from 'lucide-react';

const BackendStatusWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { backendStatus, loadActiveSession } = useSessionStore();

  useEffect(() => {
    // This component is responsible for the initial session load,
    // which doubles as our backend health check.
    if (backendStatus === 'connecting') {
      loadActiveSession();
    }
  }, [backendStatus, loadActiveSession]);

  if (backendStatus === 'connecting') {
    return (
      <div className="flex flex-col items-center justify-center h-screen bg-background">
        <Loader2 className="h-12 w-12 animate-spin text-primary" />
        <p className="mt-4 text-lg text-muted-foreground">Connecting to Repoburg backend...</p>
      </div>
    );
  }

  return <>{children}</>;
};

export default BackendStatusWrapper;
